"use strict";
// import { EMPRESAS } from '../../constants';
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonAppearance = void 0;
const getButtonAppearance = (segment) => {
    const size = {
        w: 'full',
        h: 'regular',
    };
    const color = 'secondary';
    // if (segment === EMPRESAS) {
    //   color = BUTTON_COLOR.BLUE;
    // }
    return {
        size,
        color,
    };
};
exports.getButtonAppearance = getButtonAppearance;
//# sourceMappingURL=utils.js.map